import * as Yup from 'yup';

export const latencySchema = (t: (key: string) => string) =>
  Yup.array().of(
    Yup.object().shape({
      name: Yup.string()
        .trim()
        .required(t('dashboard.latencyEdit.nameRequired')),
      address: Yup.string()
        .trim()
        .required(t('dashboard.latencyEdit.addressRequired')),
    })
  );
